<script>
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

/**
 * up sell Component
 */
export default {
  page: {
    title: "Intent",
  },
  data() {
    return {
      intentObj: {
        intent_name: "",
        text_reply: "",
        audio_file: "",
        video_file: "",
        video_file_duration: "0",
        slot_cmd: "",
      },
      image: "",
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: "",
      fileUploadLoading: false,
    };
  },

  computed: {
    ...authComputed,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.currentProps.isEdit) {
        this.intentObj.intentId = this.currentProps.updateValue.id;
        this.intentObj.intent_name = this.currentProps.updateValue.name;
        this.intentObj.text_reply = this.currentProps.updateValue.text_reply;
        this.intentObj.audio_file = this.currentProps.updateValue.audio_file;
        this.intentObj.video_file = this.currentProps.updateValue.video_file;
        this.intentObj.video_file_duration =
          this.currentProps.updateValue.video_file_duration;
        this.intentObj.slot_cmd = this.currentProps.updateValue.slot_cmd;
      }
    },

    async handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;

      let data = {};
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        data[this.intentObj.intent_name] = {
          name: this.intentObj.intent_name,
          text_reply: this.intentObj.text_reply,
          audio_file: this.intentObj.audio_file,
          video_file: this.intentObj.video_file,
          video_file_duration: this.intentObj.video_file_duration,
          slot_cmd: this.intentObj.slot_cmd,
          id: this.intentObj.intentId,
        };
        data = { ...data, id: this.currentProps.avatarId };
        if (!this.currentProps.isEdit) {
          await UserService.addUpdateBotAvatarIntent(data)
            .then(async (response) => {
              if (this.isSaveAndAddNew) {
                this.$emit("saveAndAddNew", data);
              } else {
                this.$emit("submitted", data);
              }
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);
              Middleware.notification("Something went wrong !!", "danger");

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          UserService.addUpdateBotAvatarIntent(data)
            .then((response) => {
              this.$emit("submitted", data, this.currentProps.isEdit);
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification("Successfully updated !!", "success");
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },

    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },

    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },

    async uploadFile(event, type) {
      let fileObject = event.target.files[0];
      let fileName = "";

      if (type == "audio_file") {
        this.intentObj.audio_file = this.currentProps.hotelId
          ? this.currentProps.hotelId
          : "" + "" + this.randomString(5) + ".mp3";
        fileName = { file_name: this.intentObj.audio_file };
      } else {
        this.intentObj.video_file = this.currentProps.hotelId
          ? this.currentProps.hotelId
          : "" + "" + this.randomString(5) + ".mp4";
        fileName = { file_name: this.intentObj.video_file };
      }
      this.fileUploadLoading = true;
      await UserService.mediaFileUrlGenerate(fileName)
        .then((response) => {
          let fileUrl = response.url;
          UserService.mediaFileUpload(fileUrl, fileObject).then((res) => {
            this.fileUploadLoading = false;
            this.submitted = false;
            Middleware.notification(
              "Successfully upload media file !!",
              "success"
            );
          });
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          this.createError = true;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "danger");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
  validations: {
    intentObj: {
      intent_name: {
        required,
      },
      //   fail_reply: {
      //     required,
      //   },
      text_reply: {
        required,
      },
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Edit" : "Add New" }} Intent</h4>
      <hr />
    </div>

    <div class="col-md-4">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="intent-input">
          <span slot="label"
            >Intent Name <span class="text-danger">*</span></span
          >
          <b-form-input
            id="intent-input"
            type="text"
            placeholder="intent"
            readonly
            v-model="intentObj.intent_name"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.intentObj.intent_name.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.intentObj.intent_name.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.intentObj.intent_name.required"
              >Intent name is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-4">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="intent-input">
          <span slot="label"
            >Video File Duration <span class="text-danger">*</span></span
          >
          <b-form-input
            :disabled="!currentProps.isEditable"
            id="intent-input"
            type="text"
            placeholder="Video File Duration"
            v-model="intentObj.video_file_duration"
            autocomplete="off"
            :class="{
              'is-invalid':
                submitted && $v.intentObj.video_file_duration.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.intentObj.video_file_duration.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.intentObj.video_file_duration.required"
              >Video File Duration is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-4">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="slot-cmd-input">
          <span slot="label">Slot CMD <span class="text-danger">*</span></span>
          <b-form-input
            :disabled="!currentProps.isEditable"
            id="slot-cmd-input"
            type="text"
            placeholder="Slot Cmd"
            v-model="intentObj.slot_cmd"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.intentObj.slot_cmd.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.intentObj.slot_cmd.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.intentObj.slot_cmd.required"
              >Slot CMD is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-12">
      <div class="mb-3">
        <label class="mb-1 fw-medium"
          >Text Reply <span class="text-danger">*</span></label
        >
        <textarea
          class="form-control"
          :maxlength="225"
          rows="3"
          placeholder="Text reply..."
          v-model="intentObj.text_reply"
        ></textarea>
      </div>
    </div>
    <h5 class="mt-4">
      Media

      <div
        class="spinner-border spinner-border-sm"
        role="status"
        v-show="fileUploadLoading"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </h5>

    <div class="col-md-6 mt-2">
      <label for="audio_file">Audio File</label>
      <input
        type="file"
        class="form-control"
        placeholder="Audio file"
        name="audio_file"
        @change="uploadFile($event, 'audio_file')"
        accept="audio/*"
        :src="intentObj.audio_file"
        :disabled="fileUploadLoading"
      />

      <audio
        controls
        class="mt-3 w-100"
        v-if="currentProps.isEdit && intentObj.audio_file != ''"
      >
        <source
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' + intentObj.audio_file
          "
          type="audio/mp3"
        />
      </audio>
    </div>
    <div class="col-md-6 mt-2">
      <label for="video_file">Video File</label>
      <input
        type="file"
        class="form-control"
        placeholder="Video File"
        name="video_file"
        @change="uploadFile($event, 'video_file')"
        accept="video/*"
        :src="intentObj.video_file"
        :disabled="fileUploadLoading"
      />
      <video
        width="320"
        height="240"
        controls
        autoplay
        class="mt-3 w-100"
        v-if="currentProps.isEdit && intentObj.video_file != ''"
      >
        <source
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' + intentObj.video_file
          "
        />
      </video>
    </div>
    <div class="col-md-12 mt-4">
      <b-button
        class="float-end ms-2"
        variant="outline-primary"
        type="reset"
        @click="cancelSubmit"
        :disabled="fileUploadLoading"
        >Cancel</b-button
      >
      <b-button
        v-if="this.currentProps.isEdit === false"
        class="float-end ms-2"
        variant="outline-primary"
        type="button"
        :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
        @click="saveAndAddNew"
        :disabled="fileUploadLoading"
      >
        <i
          v-if="isSaveAndAddNew === true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        Save & Add</b-button
      >
      <b-button
        class="float-end"
        :disabled="fileUploadLoading"
        variant="outline-primary"
        @click="handleSubmit"
        :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
      >
        <i
          v-if="isSaveAndAddNew !== true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        {{ currentProps.isEdit ? "Update" : "Save" }}
      </b-button>
    </div>
  </div>
</template>
